import { render, staticRenderFns } from "./NovoProcesso.vue?vue&type=template&id=e5827da6&"
import script from "./NovoProcesso.vue?vue&type=script&lang=js&"
export * from "./NovoProcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports